import React from 'react';

const DEFAULT_MESSAGE = "Thank you, the artist or their team will be in touch.";

interface WorkflowCompletionViewProps {
  message?: string;
}

const WorkflowCompletionView: React.FC<WorkflowCompletionViewProps> = ({ message }) => (
  <div className="flex flex-col items-center justify-center min-h-[40vh] gap-4 text-center px-6">
    <div className="w-16 h-16 rounded-full bg-green-100 flex items-center justify-center">
      <span className="text-3xl" role="img" aria-label="Complete">✓</span>
    </div>
    <h2 className="text-xl font-semibold text-gray-800">All done!</h2>
    <p className="text-gray-600 max-w-md">{message || DEFAULT_MESSAGE}</p>
  </div>
);

export default WorkflowCompletionView;
